module.exports = __webpack_public_path__ + "img/P36920580EL.d7c79c1e.jpg";